import type { ReactNode } from 'react'

export function StatTile({ label, value, sub, tone }: {
  label: string
  value: ReactNode
  sub?: ReactNode
  tone?: string
}) {
  return (
    <div className="card stat">
      <span className="stat-label">{label}</span>
      <span className="stat-value" style={tone ? { color: tone } : undefined}>{value}</span>
      {sub && <span className="stat-sub">{sub}</span>}
    </div>
  )
}

export function ErrorBanner({ error }: { error: unknown }) {
  if (!error) return null
  const message = error instanceof Error ? error.message : String(error)
  return <div className="banner error">{message}</div>
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="banner empty">{children}</div>
}

export function Loading({ what = 'data' }: { what?: string }) {
  return <div className="banner empty">Loading {what}…</div>
}
